export const termsContent = `
<p>Настоящее Пользовательское соглашение (далее — Соглашение) регулирует отношения между
Обществом с ограниченной ответственностью «Региональное агентство безопасности труда»
(УНП 591023480, 230023, г. Гродно, ул. 1 мая, 19; далее — Оператор) и физическим лицом,
зарегистрировавшимся на интернет-ресурсе <strong>bilet.rabt.by</strong> (далее — Пользователь).</p>

<h3>1. Предмет соглашения</h3>
<p>1.1. Оператор предоставляет Пользователю доступ к веб-тренажёру для подготовки к сдаче
экзаменов по охране труда, а также к модулю дистанционного обучения (LMS) на условиях,
описанных в настоящем Соглашении.</p>
<p>1.2. Использование интернет-ресурса означает полное и безоговорочное принятие Пользователем
условий настоящего Соглашения.</p>

<h3>2. Регистрация и учётная запись</h3>
<p>2.1. Для получения доступа к сервисам необходима регистрация с указанием действующего адреса
электронной почты и создания пароля.</p>
<p>2.2. Пользователь обязан предоставить достоверные сведения при регистрации и своевременно
обновлять их.</p>
<p>2.3. Пользователь несёт ответственность за сохранность своих учётных данных. Передача доступа
третьим лицам запрещена и является нарушением авторских прав в соответствии с Законом
Республики Беларусь «Об авторском праве и смежных правах» от 17 мая 2011 г. № 262-З.</p>

<h3>3. Подписка и доступ к тестам</h3>
<p>3.1. Доступ к модулю «Проверка знаний» предоставляется на платной основе. Доступные периоды
подписки: 3, 7 и 14 дней.</p>
<p>3.2. Подписка приобретается на одну специализацию. Для доступа к другой специализации
необходимо оформить отдельную подписку.</p>
<p>3.3. По истечении срока подписки доступ к тестам автоматически прекращается.</p>
<p>3.4. При продлении подписки оставшееся время действующей подписки суммируется со сроком
новой.</p>

<h3>4. Модуль дистанционного обучения (LMS)</h3>
<p>4.1. Оператор оказывает образовательные услуги в сфере охраны труда на основании отдельного
договора об оказании платных услуг, заключаемого в электронной форме через интернет-ресурс.</p>
<p>4.2. При оформлении договора Пользователь предоставляет персональные данные, необходимые
для его заключения и исполнения.</p>
<p>4.3. Условия, стоимость и сроки обучения определяются конкретным договором.</p>

<h3>5. Оплата</h3>
<p>5.1. Оплата подписки и образовательных услуг производится через сервис интернет-эквайринга
ЗАО «Альфа-Банк» (BIC ALFABY2X) или через систему ЕРИП.</p>
<p>5.2. Правила оплаты банковской картой опубликованы по адресу
<a href="https://rabt.by/payment-rules" target="_blank">rabt.by/payment-rules</a>.</p>
<p>5.3. В случае технических проблем с оплатой следует обратиться в службу поддержки через
страницу <a href="/support">«Помощь»</a>.</p>

<h3>6. Интеллектуальная собственность</h3>
<p>6.1. Все материалы интернет-ресурса (тестовые вопросы, учебные материалы, программное
обеспечение, дизайн) являются объектами интеллектуальной собственности Оператора или
его лицензиаров.</p>
<p>6.2. Пользователю запрещается копировать, воспроизводить, распространять или иным образом
использовать материалы сервиса без письменного согласия Оператора.</p>

<h3>7. Ограничение ответственности</h3>
<p>7.1. Оператор не несёт ответственности за временную недоступность сервиса вследствие
технических работ или обстоятельств непреодолимой силы.</p>
<p>7.2. Оператор не гарантирует, что прохождение тестов обеспечит успешную сдачу экзамена,
и не несёт ответственности за решения, принятые Пользователем на основании полученных
результатов.</p>

<h3>8. Персональные данные</h3>
<p>8.1. Порядок сбора, обработки и хранения персональных данных Пользователя описан в
<a href="/privacy">Политике обработки персональных данных</a> интернет-ресурса bilet.rabt.by.</p>

<h3>9. Изменение и расторжение соглашения</h3>
<p>9.1. Оператор вправе в одностороннем порядке изменять условия Соглашения, уведомив
Пользователя путём размещения обновлённой редакции на интернет-ресурсе.</p>
<p>9.2. Продолжение использования сервиса после вступления изменений в силу означает согласие
Пользователя с новой редакцией Соглашения.</p>

<h3>10. Применимое право и разрешение споров</h3>
<p>10.1. Соглашение регулируется законодательством Республики Беларусь.</p>
<p>10.2. Споры разрешаются путём переговоров, а при недостижении согласия — в судебном порядке
по месту нахождения Оператора.</p>

<h3>11. Контактные данные</h3>
<p>ООО «Региональное агентство безопасности труда»<br>
230023, г. Гродно, ул. 1 мая, 19<br>
тел./факс: 8 (0152) 60 92 24 &nbsp;|&nbsp; тел.: +375 29 286 11 99<br>
e-mail: <a href="mailto:office@rabt.by">office@rabt.by</a></p>
`;
